import React from "react";

import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import "react-toastify/dist/ReactToastify.css";
import "font-awesome/css/font-awesome.min.css";

import "./index.css";
import "jspanel4/es6module/jspanel.css";
import "leaflet/dist/leaflet.css";

import App from "./App";
import AuthProvider from "./providers/AuthProvider";
import DashboardProvider from "./providers/DashboardProvider";
import store from "./store";
import { icons } from "./assets/icons/index";

// @ts-ignore
React.icons = icons;

const getApp = () => {
  let app = (
    <Provider store={store}>
      <DashboardProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </DashboardProvider>
    </Provider>
  );

  return app;
};

ReactDOM.render(getApp(), document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
